/**
 * PHI-safe endpoint grouping for `api_error_encountered` (W2-R, PRD A.15).
 *
 * URLs are PHI-bearing: query strings carry search terms (phone numbers,
 * names) and paths carry record ids. Only the FIRST path segment — the API's
 * resource family ("opportunities", "consumer", "access") — may leave the
 * browser, lowercased and length-capped. Anything unparseable is "unknown".
 */
export function endpointGroupFromUrl(url: string | undefined): string {
  if (!url) {
    return "unknown";
  }
  try {
    // Base handles relative URLs; `pathname` structurally excludes the query.
    const path = new URL(url, "http://relative.local").pathname;
    const segment = path.split("/").find((s) => s.length > 0);
    if (!segment) {
      return "unknown";
    }
    return segment.toLowerCase().slice(0, 64);
  } catch {
    return "unknown";
  }
}
